export default "__VITE_ASSET__B75yBs6Q__"